import {ChangeDetectionStrategy, Component, Inject, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {Level} from "@tiptap/extension-heading";
import {NodeType, TipTapEditor, TipTapEditor_DI_TOKEN} from "../../tiptap/TipTapEditor";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('RiktekstRedigeringOverskriftVelgerKomponentKomponent');

/**
 * Skjema for å endre overskriftsnivå
 */
@Component({
    selector: 'riktekst-redigering-overskrift-velger',
    templateUrl: 'overskrift-velger.html',
    styleUrl: 'overskrift-velger.scss',
    imports: [
        MatSelect,
        MatOption,
        ReactiveFormsModule,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringOverskriftVelgerKomponentKomponent {

    aktivert = output<boolean>();

    kontroll = new FormControl<Level | 0>(0);
    overskrifter = this.tilgjengeligeOverskrifter();

    constructor(@Inject(TipTapEditor_DI_TOKEN) protected editor: TipTapEditor, private oversettelser: Oversettelser) {
        this.kontroll.valueChanges
          .pipe(takeUntilDestroyed())
          .subscribe(nivå => this.setOverskriftsnivå(nivå!));

        this.editor.vedTilstandEndret(() => this.lesOverskriftsnivå())
          .subscribe(overskrift => this.kontroll.setValue(overskrift, {emitEvent: false})); //emitEvent:false slik at ikke kontroll.valueChanges trigges
    }

    formatertNavn(overskrift:Overskrift){
        return `<${overskrift.htmlTag}>${overskrift.navn}</${overskrift.htmlTag}>`;
    }

    vedMenyLukket() {
        this.aktivert.emit(false);
    }

    vedMenyAapnet() {
        this.aktivert.emit(true);
    }

    //private hjelpemetoder

    private lesOverskriftsnivå() {
        return this.editor.editor.getAttributes(NodeType.Heading).level ?? 0;
    }

    private setOverskriftsnivå(overskrift: Level | 0) {
        if (overskrift === 0)
          //endre fra heading til ordinær paragraf
            this.editor.editor.chain().focus().toggleNode(NodeType.Heading, NodeType.Paragraph).run();
        else
            this.editor.editor.chain().focus().setHeading({level: overskrift}).run();
    }

    private tilgjengeligeOverskrifter(): Overskrift[] {
        return [
            // canSelectNullableOptions direktivet kommer ikke før i ng19, inntill da bruker vi '0' for å repr at ingen overskrift er valgt
            {nivaa: 0, navn: this.oversettelser.oversett('Normal tekst'), htmlTag:  'span'},
            {nivaa: 1, navn: this.oversettelser.oversett('Overskrift 1'), htmlTag: 'h1'},
            {nivaa: 2, navn: this.oversettelser.oversett('Overskrift 2'), htmlTag: 'h2'},
            {nivaa: 3, navn: this.oversettelser.oversett('Overskrift 3'), htmlTag: 'h3'},
            {nivaa: 4, navn: this.oversettelser.oversett('Overskrift 4'), htmlTag: 'h4'},
            {nivaa: 5, navn: this.oversettelser.oversett('Overskrift 5'), htmlTag: 'h5'},
            {nivaa: 6, navn: this.oversettelser.oversett('Overskrift 6'), htmlTag: 'h6'},
        ];
    }
}

type Overskrift = { nivaa: Level | 0, navn: string, htmlTag:string; };
